import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import SummaryApi from "../common/index";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem("user");
      return savedUser ? JSON.parse(savedUser) : null;
    } catch {
      return null;
    }
  });

  const [loading, setLoading] = useState(true);

  // ✅ Set global Axios token once
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  }, []);

  // ✅ Login handler
  const login = (userData, token, role) => {
    const userWithRole = { ...userData, role };
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userWithRole));
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setUser(userWithRole);
  };

  // ✅ Logout handler
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    delete axios.defaults.headers.common["Authorization"];
  };

  // ✅ Fetch user profile safely
  const fetchProfile = async () => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (!token || !storedUser) {
      setUser(null);
      delete axios.defaults.headers.common["Authorization"];
      setLoading(false);
      return;
    }

    const parsedUser = JSON.parse(storedUser);

    // Skip API call for seller/admin — use stored info
    if (["seller", "admin"].includes(parsedUser.role)) {
      setUser(parsedUser);
      setLoading(false);
      return;
    }

    try {
      const res = await axios.get(SummaryApi.getUserProfile.url);
     if (res.data.success) {
  const apiUser = res.data.user;

  const normalizedUser = {
    ...apiUser,
    profilePic: apiUser.profilePic || apiUser.profile_pic || null,
  };

  setUser(normalizedUser);
  localStorage.setItem("user", JSON.stringify(normalizedUser));
}
else {
        logout();
      }
    } catch (err) {
      console.error("Fetch profile failed:", err);
      logout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        loading,
        fetchProfile,
        role: user?.role || null, // ✅ easy access anywhere
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
